import { render, staticRenderFns } from "./ProcessRiskScenario.vue?vue&type=template&id=477e7810&scoped=true&"
import script from "./ProcessRiskScenario.vue?vue&type=script&lang=js&"
export * from "./ProcessRiskScenario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "477e7810",
  null
  
)

export default component.exports